<template>

  <div class="col col-sm-2">
    <template v-if="(isManning && !guest) || isOchg">
      <template v-if="crew.active == 1 || isSystemAdmin || isOchg">
        <button class="btn btn-sm btn-xs"
                data-toggle="modal" data-target="#edit-email"
                title="Edit Crew Email"
                @click="email = crew.email"
        >
          <span class="fas fa-edit"></span>
        </button>
      </template>
    </template>
    <app-modal unique="edit-email" title="EDIT EMAIL">
      <form @submit.prevent="confirmUpdateEmail">
        <div class="form-group form-row mb-1">
          <label class="col col-sm-3 col-form-label font-weight-bolder text-right" for="crew-email">
            Email:
          </label>

          <div class="col col-sm-6">
            <input type="email" id="crew-email" required
                   class="form-control form-control-xs"
                   placeholder="TYPE CREW EMAIL HERE"
                   v-model="email"
            >
            <span class="help-block text-danger" v-if="emailErrors.email">
                                    <small><strong>{{ emailErrors.email }}</strong></small>
                                </span>
          </div>

          <div class="col col-3 align-middle">

            <button type="submit" class="btn btn-sm btn-warning font-weight-bolder align-self-center">
              <span class="fas fa-edit"></span>
              Update
            </button>
          </div>
        </div>
      </form>
    </app-modal>
  </div>
</template>

<script>
/* eslint-disable */
import {vueAppMixin} from '@/mixins/vueAppMixin';
import {gateMixin} from '@/mixins/gateMixin';
import {mapActions, mapGetters} from 'vuex';

import AppModal from "@/components/elements/AppModal";

export default {
  name: "UpdateCrewEmail",

  mixins: [vueAppMixin, gateMixin],

  components: {AppModal},

  data() {
    return {
      email: '',
      emailErrors:{},
    }
  },

  methods: {
    ...mapActions([
      'updateCrewEmail'
    ]),

    async confirmUpdateEmail() {
      if (await this.confirmUpdate()) {
        let params = {
          id: this.crew.id,
          email: this.email
        }
        let updatedCrewEmail = await this.updateCrewEmail(params);
        if (!updatedCrewEmail.errors) {
          this.emailErrors={}
          this.successAlert('Email Successfully Updated', 'UPDATE');
          document.getElementById('close-edit-email').click();
        } else {
          this.emailErrors=Object.assign({},updatedCrewEmail.errors)
        }
      }
    }

  },

  computed: {
    ...mapGetters([
      'crew'
    ])
  },

  watch: {
    'crew.email'() {
      this.email = this.crew.email;
    }
  },

  created() {
    this.email = this.crew.email;
  }
}
</script>

<style scoped>

</style>